module.exports = __webpack_public_path__ + "static/scale-model-of-vintage-tours-miami-in-miami-gardens-florida-4de30870f0f3f8e37fd321b6c56f515f.png";